<template>
    <div class='ReportTools row'>
        <div class='col-6'>
            <h1 class='display-4'>{{ reportTitle }}</h1>
        </div>
        <!--
        <div class='col-4'>
            <button
                v-for='button in reportButtons'
                type="button"
                class="btn"
                :class="button.class"
                @click='handleReportButtonClick(button.action)'
            >
                {{ button.label}}
            </button>
        </div>
        -->
        <div class='col-4'>
            <slot name='buttons'></slot>
        </div>
        <div class='col-2'>
            <div class='row'>
                <div class='col-10'>
                    <input class='reportFilter' placeholder="Search table here" :value='textFilter' @keydown='updateTextFilter' :disabled='tableIsLoading'/>
                </div>
                <div class='col-2 searchIconContainer'>
                    <SearchIcon />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import SearchIcon from '../../icons/SearchIcon.vue';
    export default {
        name: 'ReportTools',
        components: {
            SearchIcon
        },
        props: ['textFilter', 'tableIsLoading', 'reportButtons', 'reportTitle'],
        data(){ return{
            filterTimeout: null
        }},
        methods: {
            updateTextFilter(e){
                if(this.filterTimeout) clearTimeout(this.filterTimeout);
                this.filterTimeout = setTimeout(() => {
                    this.$emit('update-text-filter', e.target.value)
                }, 400);
            },
            handleReportButtonClick(action){
                this.$emit('report-button-clicked', {action: action })
            }
        }
    }
</script>
